export default __webpack_public_path__ + "static/media/education.ad2dff7c.png";